/**
 * ETA Build brand mark — square yellow tile with construction helmet icon.
 * Restored classic look (CantierePro-style) but keeps the new ETA Build name.
 */
export function LogoMark({ size = 48, className = "" }) {
  return (
    <div
      className={`inline-flex items-center justify-center bg-[#FFD600] rounded-md ${className}`}
      style={{ width: size, height: size }}
      aria-label="ETA Build"
      role="img"
    >
      <svg
        width={size * 0.6}
        height={size * 0.6}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        fill="#0A0A0A"
      >
        {/* Construction helmet (hard hat) silhouette */}
        <path d="M4 22 L4 26 L28 26 L28 22 Z" />
        <path d="M6 22 L6 18 C6 12 10 8 16 8 C22 8 26 12 26 18 L26 22 Z" />
        {/* Top crest line */}
        <rect x="14" y="6" width="4" height="3" rx="0.5" />
      </svg>
    </div>
  );
}

export function LogoWordmark({ size = 28, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoMark size={size} />
      <span className="font-heading font-black uppercase tracking-tight leading-none"
        style={{ fontSize: `${size * 0.78}px` }}>
        ETA<span className="text-[#FFD600]">Build</span>
      </span>
    </div>
  );
}
